import { memo } from "react";

import { QuestionPlanMainTarget } from "@/components/features/items/edit/plan/_shared/ui/components/main-target";

import { useDayTripPlanMainTarget } from "./hooks";

export const QuestionDayTripPlanMainTarget = memo(() => {
	const { mainTarget, onSetMainTarget } = useDayTripPlanMainTarget();

	return <QuestionPlanMainTarget mainTarget={mainTarget} onSetMainTarget={onSetMainTarget} />;
});

QuestionDayTripPlanMainTarget.displayName = "QuestionDayTripPlanMainTarget";
